export enum IHttpMethod {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum ServicesURL {
  CRYPTOCRONTROL = 'cryptocontrol',
}
